import React, { useState, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import moment from "moment";
import queryString from "query-string";

import PointsCard from "../../components/Rewards/PointsCard";
import Tabs from "../../components/Rewards/Tabs";
import RewardsTab from "../../components/Rewards/RewardsTab";
import RedeemedTab from "../../components/Rewards/RedeemedTab";

import { newFetch, GET, POST } from "../../helpers/fetch";

const Rewards = ({ history, location: { search } }) => {
  const params = queryString.parse(search);
  const associate_id = JSON.parse(localStorage.getItem("user")).id;
  const tabs = ["Rewards", "Redeemed"];

  const [cart, setCart] = useState(
    localStorage.getItem("cart") ? JSON.parse(localStorage.getItem("cart")) : []
  );

  const [cartQuantity, setCartQuantity] = useState(0);

  const [activeTab, setActiveTab] = useState(
    params.activeTab ? params.activeTab : "Rewards"
  );

  const handleToggleTab = (tab) => {
    history.push({
      pathname: `/rewards`,
      search: queryString.stringify({
        activeTab: tab,
      }),
    });
  };

  const [userPoints, setUserPoints] = useState(0);
  const [rewards, setRewards] = useState([]);
  const [redeemedRewards, setRedeemedRewards] = useState([]);

  const fetchUserPoints = async () => {
    let api_path = "/associate/aboutme";
    let response = await newFetch(GET, api_path);

    if (response.success && response.data.new_reward_points) {
      let new_reward_points = response.data.new_reward_points;
      const total = associatePointsHandler(new_reward_points);
      setUserPoints(total);
    }
  };

  const fetchRewards = async () => {
    let api_path = `/reward`;
    let response = await newFetch(GET, api_path);

    response.success && setRewards(response.results);
  };

  const fetchRedeemedRewards = async () => {
    let api_path = `/reward/associate/${associate_id}/redeemed`;
    let response = await newFetch(GET, api_path);
    if (response.success) {
      let sortedData = response.data.sort((a, b) =>
        moment(a.createdAt).isBefore(moment(b.createdAt)) ? 1 : -1
      );
      setRedeemedRewards(sortedData);
    }
  };

  const associatePointsHandler = (data) => {
    const finalTotalPoints = data.reduce((total, points) => {
      let computedExpiredAndUsePoints =
        parseFloat(points.total_expired) + parseFloat(points.total_used);
      let totalEarnedBalance =
        parseFloat(points.total_earned) - computedExpiredAndUsePoints;

      return total + totalEarnedBalance;
    }, 0);

    return finalTotalPoints;
  };

  // const handleAddToCart = (item_id, quantity = 1) => {
  //   let itemToAdd = rewards.find(item => item.id === item_id)

  //   localStorage.setItem(cart)
  // }

  // const handleRedeem = async item_id => {
  //   let quantity = window.prompt('Insert number of item to redeem.', 1)

  //   if (quantity) {
  //     quantity = parseInt(quantity)

  //     if (isNaN(quantity)) {
  //       alert('Input is not a number')
  //     } else {
  //       if (quantity <= 0) {
  //         alert('Quantity should be more than zero.')
  //       } else {
  //         let api_path = `/reward/${item_id}/redeem`
  //         let response = await newFetch(POST, api_path, { quantity })

  //         alert(response.message)

  //         if (response.success) {
  //           fetchUserPoints()
  //           fetchRewards()
  //           fetchRedeemedRewards()
  //         }
  //       }
  //     }
  //   }
  // }

  useEffect(() => {
    fetchUserPoints();
    fetchRewards();
    fetchRedeemedRewards();
  }, []);

  useEffect(() => {
    if (cart && cart.length > 0) {
      let total = cart.reduce(
        (total, cartItem) => total + cartItem.quantity,
        0
      );
      setCartQuantity(total);
    } else {
      setCartQuantity(0);
    }
  }, [cart]);

  useEffect(() => {
    setActiveTab(params.activeTab ? params.activeTab : "Rewards");
  }, [params]);

  return (
    <>
      <div className="container pt-4 d-flex flex-column">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="text-brand">
            <Link to="/">
              <i
                className="fas fa-arrow-left link"
                style={{ cursor: "pointer" }}
              />
            </Link>
            &nbsp;&nbsp;Rewards
          </h4>{" "}
          <button
            type="button"
            className="btn btn-brand text-white shadow-sm"
            onClick={() => history.push("/rewards/cart")}
          >
            <i className="fas fa-shopping-cart"></i>
            {cart.length > 0 && (
              <span className="badge badge-brand ml-2">{cartQuantity}</span>
            )}
          </button>
        </div>
        <PointsCard points={userPoints} />
        <div className="container bg-white pb-1">
          <Tabs
            tabs={tabs}
            activeTab={activeTab}
            handleToggleTab={handleToggleTab}
          />
          {activeTab === "Rewards" && (
            <RewardsTab rewards={rewards} cart={cart} setCart={setCart} />
          )}
          {activeTab === "Redeemed" && (
            <RedeemedTab redeemedRewards={redeemedRewards} />
          )}
        </div>
      </div>
    </>
  );
};

export default withRouter(Rewards);
